import { render, staticRenderFns } from "./StrdD_Items.vue?vue&type=template&id=2e60373e"
import script from "./StrdD_Items.vue?vue&type=script&lang=js"
export * from "./StrdD_Items.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports